<ag-grid-angular #agGrid
      style="width: 100%; height: 500px;"
      id="myGrid"
      class="ag-theme-alpine"
      [columnDefs]= "gridProperties.columnDefinitions"
      [rowData]="gridData"
      rowSelection="multiple"
      [animateRows]="true"
      [suppressMenuHide]="false"
    >
</ag-grid-angular>